/* Simply Trees: tidy the header grow-zone widget and the Growzone Finder pop-up copy. Only touches labels; the app keeps doing the lookups. */
(function () {
  'use strict';
  var PIN = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M12 2a7 7 0 0 0-7 7c0 5.3 7 13 7 13s7-7.7 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" fill="currentColor"/></svg>';
  function firstText(el, txt) {
    for (var i = 0; i < el.childNodes.length; i++) { var n = el.childNodes[i]; if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = txt; return; } }
    el.insertBefore(document.createTextNode(txt), el.firstChild);
  }

  function header() {
    document.querySelectorAll('.header__top a.button[href*="k-hub"], .header__top a.button[href*="/account"]').forEach(function (a) { a.setAttribute('aria-label', 'Account'); a.setAttribute('title', 'Account'); });
    document.querySelectorAll('growzone-popup-widget').forEach(function (w) {
      var z = w.querySelector('[data-growzone]'), check = function () { w.classList.toggle('sth-gz-empty', !(z && z.textContent.trim())); };
      if (!w.hasAttribute('aria-label')) { w.setAttribute('role', 'button'); w.setAttribute('tabindex', '0'); w.setAttribute('aria-label', 'Change your grow zone'); w.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); w.click(); } }); }
      if (w.classList.contains('portable-show')) {
        /* drop the stray ":" between "Planting in" and the ZIP */
        w.querySelectorAll('.plant_zone, .grow_zone').forEach(function (row) {
          Array.prototype.slice.call(row.childNodes).forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim() === ':') n.textContent = ' '; });
          var lab = row.querySelector('div'); if (lab) lab.textContent = lab.textContent.replace(/:\s*$/, '').trim();
        });
      }
      check();
      if (z && window.MutationObserver) new MutationObserver(check).observe(z, { childList: true, characterData: true, subtree: true });
    });
  }

  function popup() {
    var pop = document.querySelector('.growzone-finder--popup');
    if (!pop || pop.getAttribute('data-sth-done')) return !!pop;
    pop.setAttribute('data-sth-done', '1');
    pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-modal', 'true'); pop.setAttribute('aria-label', 'Find your grow zone');
    var close = pop.querySelector('.growzone-finder--close .button');
    if (close) { close.textContent = '×'; close.setAttribute('aria-label', 'Close'); }
    var content = pop.querySelector('.growzone-finder--popup--content'), h = content && content.querySelector('h2'), p = content && content.querySelector('p');
    if (h) {
      var ic = document.createElement('div'); ic.className = 'sth-gz-pin'; ic.innerHTML = PIN; h.parentNode.insertBefore(ic, h);
      h.textContent = 'Find your grow zone';
    }
    if (p) p.textContent = "Enter your ZIP and we'll show the plants that thrive where you live, plus a more accurate ship date for your area.";
    var form = pop.querySelector('form');
    if (form) {
      var lab = form.querySelector('label'); if (lab) lab.textContent = 'ZIP code';
      var input = form.querySelector('input[name="zip"]'); if (input) { input.setAttribute('inputmode', 'numeric'); input.setAttribute('autocomplete', 'postal-code'); input.setAttribute('placeholder', 'e.g. 75494'); }
      var rows = Array.prototype.slice.call(form.children).filter(function (el) { return el.tagName === 'P' && el.querySelector('strong'); });
      if (rows.length >= 2) {
        var wrap = document.createElement('div'); wrap.className = 'sth-gz-stats';
        rows[0].parentNode.insertBefore(wrap, rows[0]);
        rows.forEach(function (r) {
          var t = r.querySelector('[data-growzone]') ? 'Your zone' : 'ZIP code';
          firstText(r, t); wrap.appendChild(r);
        });
      }
      var cur = form.querySelector('.growzone-finder--use-current-location'); if (cur) cur.textContent = 'Use my current location';
    }
    return true;
  }

  function boot() {
    header();
    if (!popup() && window.MutationObserver) {
      var mo = new MutationObserver(function () { if (popup()) mo.disconnect(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
